<p-table
    #beSharpTable
    
    [columns]="exportColumnHeaders"
    [value]="tableItems" 
    [totalRecords]="totalRecords"
    [loading]="loading"
    [tableStyle]="{ 'min-width': '50rem' }" 
    [size]="size"
    [sortField]="defaultActive || tableDefinitions[0].def"
    [sortOrder]="defaultDirection || 1"
    [paginator]="paginator"
    [rows]="pageRows"
    [rowsPerPageOptions]="pageRowsOptions"
    [showCurrentPageReport]="showCurrentPageReport"
    [currentPageReportTemplate]="currentPageReportTemplate || ''"
    [showGridlines]="showGridLines"
    [stripedRows]="showStripes"
    [globalFilterFields]="globalFilterFields"
    [rowHover]="rowOverEffect"
    [(selection)]="checkedItemsArray"
    (onFilter)="searchFilterEvent($event)"
    (onRowSelect)="rowSelectionEvent($event)"
    (onRowUnselect)="rowDeSelectionEvent($event)"
    (onHeaderCheckboxToggle)="manageAllRowsSelection($event);"
    [lazy]="lazyMode"
    (onLazyLoad)="filterChangedEvent($event)"
    (onPage)="handlePageChange($event)"
    (rowsChange)="pageRows = $event"
    (onSort)="sortChangedEvent($event)"
    (onFilter)="handleFilterChangedEvent($event)"
>

    <ng-template #caption>
        <div class="row">
            <div class="col-1">
                <p-button *ngIf="showClearFiltersButton" label="Clear" [outlined]="true" icon="pi pi-filter-slash" (click)="clearFilters()" />
            </div>
            <div class="col-1">
                <p-button *ngIf="showExportButton" [outlined]="true" icon="pi pi-external-link" label="Export Csv" (click)="beSharpTable.exportCSV()" />
            </div>
            <div class="col-10 search-bar-container">
                <p-iconfield *ngIf="showSearchInput" iconPosition="left" class="search-bar">
                    <p-inputicon>
                        <i class="pi pi-search"></i>
                    </p-inputicon>
                    <input
                        #searchInput
                        pInputText
                        type="text"
                        (input)="searchInputRequest($event)"
                        placeholder="Search keyword"
                    />
                </p-iconfield>
            </div>
        </div>
    </ng-template>

    <ng-template #header>
        <tr>
            <th *ngIf="hasCheckboxes" style="width: 4rem"><p-tableHeaderCheckbox /></th>
            <ng-container *ngFor="let columnDefinition of tableDefinitions">

                <th [pSortableColumn]="columnDefinition.sortable ? columnDefinition.def: undefined">
                    {{columnDefinition.title}} <p-sortIcon *ngIf="columnDefinition.sortable" [field]="columnDefinition.def" />
                    <p-columnFilter *ngIf="columnDefinition.columnFilter && columnDefinition.def === 'lastConnected'" type="date" [field]="columnDefinition.def" display="menu" showIcon="true" showAddButton="false" showMatchModes="false"/> 
                    <p-columnFilter *ngIf="columnDefinition.columnFilter && columnDefinition.def !== 'lastConnected'" type="text" [field]="columnDefinition.def" display="menu" showIcon="true" showAddButton="false" showMatchModes="false"/> 
                </th>
            </ng-container>
            <ng-container *ngIf="actionDefinitions && actionDefinitions.length > 0">
                <th>{{actionTitle}}</th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template #body let-rowData>
        <tr (click)="rowClickedEvent($event, rowData)">
            <td *ngIf="hasCheckboxes"><p-tableCheckbox [value]="rowData"/></td>
            <td *ngFor="let columnDefinition of tableDefinitions">
                <!-- Here we apply some custom formatting for different types of use cases -->
                <!-- Editable Columns -->
                @if (columnDefinition.def == 'description' || columnDefinition.def == 'supportedMachines') {
                    <div style="display: flex; align-items: center;">
                        <p-button 
                            [style]="{ 'padding': '5px'}"
                            icon="pi pi-pencil"
                            [outlined]="true"
                            size="small"
                            pTooltip="Edit {{ columnDefinition.title }}"
                            tooltipPosition="left"
                            (click)="onEditClick({ rowData, columnDefinition })"
                        />
                        <span style="position: relative; left: 10px">
                            {{ rowData[columnDefinition.def] }}
                        </span>
                    </div>
                }
                <!-- Other Columns -->
                @else {
                        <!-- Standard Text -->
                    <div [pTooltip]="columnDefinition.tooltip ? columnDefinition.tooltip(rowData) : undefined" [tooltipPosition]="columnDefinition.tooltipPosition || 'top'">
                        <!-- Custom: lastConnected formatted date -->
                        <span *ngIf="columnDefinition.def === 'lastConnected'">
                            {{ formatLastConnected(rowData[columnDefinition.def]) }}
                        </span>
                        <!-- Standard Text -->
                        <span *ngIf="
                            columnDefinition.def !== 'lastConnected' &&
                            !columnDefinition.transformer &&
                            !columnDefinition.json &&
                            !columnDefinition.link &&
                            !columnDefinition.currency &&
                            !columnDefinition.image &&
                            !columnDefinition.rating"
                        >{{ rowData[columnDefinition.def] }}</span>
                        <!-- Transformer -->
                        <span *ngIf="columnDefinition.transformer && columnDefinition.def !== 'lastConnected'" [innerHTML]="columnDefinition.transformer(rowData[columnDefinition.def])"></span>
                        <!-- Json -->
                        <pre *ngIf="columnDefinition.json" [innerHTML]="applyJsonFormatting(rowData[columnDefinition.def])" class=json-container></pre>
                        <!-- Link -->
                        <div *ngIf="columnDefinition.link"><a [href]="rowData[columnDefinition.def]" class="link-cell" target="_blank">{{rowData.linkLabel || columnDefinition.title}}</a></div>
                        <!-- Currency -->
                        <span *ngIf="columnDefinition.currency">{{ rowData[columnDefinition.def] | currency : (columnDefinition.currencyCode || 'EUR') }}</span>
                        <!-- Image -->
                        <div *ngIf="columnDefinition.image"><img [class]="columnDefinition.imageShadow ? 'shadow' : undefined" [src]="rowData[columnDefinition.def]" [alt]="setImageLabel(columnDefinition, rowData) || columnDefinition.title" [title]="setImageLabel(columnDefinition, rowData) || columnDefinition.title"/></div>
                        <!-- Rating -->
                        <span *ngIf="columnDefinition.rating"><p-rating [(ngModel)]="rowData[columnDefinition.def]" (ngModelChange)="ratingChangedEvent(rowData)"></p-rating></span>
                    </div>
                }
            </td>

            <ng-container *ngIf="actionDefinitions && actionDefinitions.length > 0">
                <td>
                    <!-- Dropdown menu mode -->
                    <ng-container *ngIf="!showActionsAsButtons">
                        <p-menu #menu
                            [model]="(dynamicMenuItems$ | async)!"
                            [popup]="true"
                            appendTo="body"
                            (onShow)="showMenu(rowData)">
                        </p-menu>
                        <p-button variant="text" severity="secondary" (click)="menu.toggle($event);" styleClass="table-action-button" rounded>
                            <i class="pi pi-ellipsis-v"></i>
                        </p-button>
                    </ng-container>
                    
                    <!-- Separate buttons mode -->
                    <ng-container *ngIf="showActionsAsButtons">
                        <div class="action-buttons-container">
                            <p-button 
                                *ngFor="let action of actionDefinitions"
                                [icon]="action.icon"
                                [label]="typeof action.label === 'function' ? action.label(rowData) : action.label"
                                [styleClass]="action.styleClass + ' action-button'"
                                size="small"
                                (onClick)="action.callback(rowData)"
                                [disabled]="action.active && !action.active(rowData)">
                            </p-button>
                        </div>
                    </ng-container>
                </td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody" >
        <tr *ngFor="let _ of [].constructor(pageRows)">
          <td *ngIf="hasCheckboxes"><p-skeleton width="100%" height="1.5em" style="margin: 0.25em 0;"></p-skeleton></td>
          <td *ngFor="let col of tableDefinitions">
            <p-skeleton width="100%" height="1.5em" style="margin: 0.25em 0;"></p-skeleton>
          </td>
          <td *ngIf="actionDefinitions && actionDefinitions.length > 0">
            <p-skeleton width="34px" height="34px" shape="circle"></p-skeleton>
          </td>
        </tr>
    </ng-template>
</p-table>